import {
  ElementRef,
  NgZone
} from '@angular/core';
import * as _ from 'lodash';

import { BehaviorSubject ,  Observable } from 'rxjs';

import CurrencyCodeMapper from 'utils/currency-code-mapper';
import { pricingConfig } from './pricing-config';
import { getPriceSheets } from 'shared/price-sheet/price-sheet-helpers';

export class PricingMixin {

  data: any;
  sortDirection: string = 'asc';
  priceSheetsItems1: any;
  priceSheetsItems2: any;
  priceSheetsDropdown1: any;
  priceSheetsDropdown2: any;
  currency: any;
  isComponentActive: boolean = true;

  onPriceSheetChange(priceSheet: any, number: number) {
    (<any>this)[`selectedPriceSheet${number}`] = priceSheet;
  }

  onPriceTypeSortClick() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    const order: Array<boolean | 'asc' | 'desc'> = this.sortDirection === 'asc' ? ['asc'] : ['desc'];
    this.data = _.orderBy(this.data, ['title'], order);
    (<any>this).showMoreData = _.orderBy((<any>this).showMoreData, ['title'], order);
  }

  public addCurrencyDropdownData(): void {
    this.currency = _.map(CurrencyCodeMapper.getCurrencyList(), (item: any) => {
      item.title = item.name;
      item.active = item.code === 'USD';
      return item;
    });
  }

  public addDropdownPriceSheets(priceSheets: any): void {
    const dropdownPriceSheets = getPriceSheets(priceSheets);
    this.priceSheetsItems1 = dropdownPriceSheets;
    if (dropdownPriceSheets && dropdownPriceSheets.length > 1) {
      this.priceSheetsItems2 = _.cloneDeep(dropdownPriceSheets);
    }
    if (!this.priceSheetsItems1.length) { return; }
    const primary = _.find(this.priceSheetsItems1, ['default', 1]) || this.priceSheetsItems1[0];
    const secondary = _.find(this.priceSheetsItems1, ['default', 2]) || this.priceSheetsItems1[1];
    _.defer(() => {
      this.priceSheetsDropdown1.setActive(primary.id);
      if (!this.priceSheetsItems1[1]) { return; }
      this.priceSheetsDropdown2.setActive(secondary.id);
    });
  }
}
